import React from 'react'
import { styled, Grid as BaseGrid } from '@mui/material'

export const Column = styled(({ flexGrow, margin, padding, width, ...props }) => <BaseGrid item {...props} />)`
  flex-grow: ${props => props.flexGrow ?? ''};
  margin: ${props => props.margin || '0'};
  padding: ${props => props.padding || '0 5px'};
  width: ${props => props.width};
`

export const Row = styled(({ margin, padding, ...props }) => <BaseGrid container {...props} />)`
  margin: ${props => props.margin || '0 -5px'};
  padding: ${props => props.padding || '0'};
`
